import { Flex, Box, Anchor, rem } from "@mantine/core";
import { Link } from "react-router-dom";
import MobileHamburger from "./MobileHamburger";
import { useAuth } from "../../hooks/useAuth";
import NavbarMarqueeBand from "./NavbarMarqueeBand";
import { useLandingNavAuthPaths } from "./landingNavAuthPaths.context";

export const LANDING_NAVBAR_HEIGHT = 64;
export const LANDING_NAVBAR_MARQUEE_HEIGHT = 38;

const NAV_ROW_INNER_HEIGHT = LANDING_NAVBAR_HEIGHT;
const NAV_AUTH_ACTIONS_GAP = 18;
const NAV_LOGO_HEIGHT = 40;
const NAV_NAVY = "#04305c";

const findCollaborationsStyles = {
  root: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    fontSize: rem(14),
    fontWeight: 600,
    lineHeight: 1.25,
    paddingTop: rem(8),
    paddingBottom: rem(8),
    paddingLeft: rem(18),
    paddingRight: rem(18),
    borderRadius: "var(--mantine-radius-xl)",
    boxSizing: "border-box" as const,
    backgroundColor: "#ffffff !important",
    color: `${NAV_NAVY} !important`,
    border: `1px solid ${NAV_NAVY}`,
    "&:hover": {
      backgroundColor: "#f8fafc !important",
      color: `${NAV_NAVY} !important`,
    },
  },
};

type LandingNavbarProps = {
  showMarquee?: boolean;
};

export default function LandingNavbar({ showMarquee = false }: LandingNavbarProps) {
  const { isAuthenticated } = useAuth();
  const { loginPath, signupPath } = useLandingNavAuthPaths();

  const marqueeHeight = showMarquee ? LANDING_NAVBAR_MARQUEE_HEIGHT : 0;
  const headerHeight = LANDING_NAVBAR_HEIGHT + marqueeHeight;

  return (
    <Box
      component="header"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 50,
        background: "#ffffff",
        borderBottom: "1px solid #e4e8ee",
        height: headerHeight,
      }}
    >
      <Flex
        align="center"
        justify="space-between"
        style={{ height: NAV_ROW_INNER_HEIGHT, maxWidth: 1414, margin: "0 auto", padding: "0 20px", gap: 12 }}
      >
        <Anchor component={Link} to="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", flexShrink: 0 }}>
          <img
            src="/gtLogo.svg"
            alt="GTsetu"
            style={{ height: NAV_LOGO_HEIGHT, width: "auto", maxWidth: 110, display: "block" }}
          />
        </Anchor>

        <Flex component="nav" aria-label="Primary" gap={NAV_AUTH_ACTIONS_GAP} align="center" wrap="nowrap">
          {!isAuthenticated ? (
            <Flex gap={NAV_AUTH_ACTIONS_GAP} align="center" visibleFrom="sm" wrap="nowrap">
              <Anchor component={Link} to="/" styles={findCollaborationsStyles}>
                Find Collaborations
              </Anchor>
              <Link to={loginPath} className="landing-navbar-auth-btn landing-navbar-login">
                Login
              </Link>
              <Link to={signupPath} className="landing-navbar-auth-btn landing-navbar-signup">
                Signup
              </Link>
            </Flex>
          ) : null}
          <MobileHamburger isAuthenticated={isAuthenticated} />
        </Flex>
      </Flex>
      {showMarquee ? <NavbarMarqueeBand /> : null}
    </Box>
  );
}

export function landingNavbarOffset(showMarquee = false) {
  return LANDING_NAVBAR_HEIGHT + (showMarquee ? LANDING_NAVBAR_MARQUEE_HEIGHT : 0);
}
